import FullWidth from './FullWidth';

export default FullWidth;
